import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "helios_content_v1";
const PASS_KEY = "helios_admin_pass";

const SiteContentContext = createContext(null);

export const useSiteContent = () => useContext(SiteContentContext);

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(() => {
    try {
      const c = localStorage.getItem(CACHE_KEY);
      return c ? JSON.parse(c) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(!content);

  const hydrate = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent(data);
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch {
      /* keep cache */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { hydrate(); }, [hydrate]);

  const save = useCallback(async (next, passcode) => {
    const { data } = await axios.put(`${API}/content`, next, {
      headers: { "X-Admin-Passcode": passcode },
    });
    setContent(data);
    localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    return data;
  }, []);

  return (
    <SiteContentContext.Provider value={{ content, loading, refresh: hydrate, save }}>
      {children}
    </SiteContentContext.Provider>
  );
};

// --- admin passcode helpers ---
export const adminApi = {
  async login(passcode) {
    await axios.post(`${API}/admin/login`, { passcode });
    localStorage.setItem(PASS_KEY, passcode);
    return true;
  },
  getPass() {
    return localStorage.getItem(PASS_KEY) || "";
  },
  logout() {
    localStorage.removeItem(PASS_KEY);
  },
  async fetchAdminContent(passcode) {
    const { data } = await axios.get(`${API}/admin/content`, {
      headers: { "X-Admin-Passcode": passcode },
    });
    return data;
  },
  async fetchLeads(passcode) {
    const { data } = await axios.get(`${API}/leads`, {
      headers: { "X-Admin-Passcode": passcode },
    });
    return data;
  },
};
